import React, { Component } from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    return ({
        currentScript: state.convo.meta.currentScript,
        articleA: state.convo.meta.articleA,
        articleB: state.convo.meta.articleB,
        showLinks: state.convo.meta.showLinks
    });
}
class ScriptBar extends Component {
    render() {
        let articleLinks = (
        <h2>This conversation is based on the following articles: 
            <ol>
                <li><a href={this.props.articleA}>{this.props.articleA}</a></li>
                <li><a href={this.props.articleB}>{this.props.articleB}</a></li>
            </ol>
        </h2>);
        let script = this.props.showLinks ? articleLinks : (<h2>{this.props.currentScript}</h2>);
        return (
            <div>
                {script}
            </div>
        );
    }
}

export default connect(mapStateToProps)(ScriptBar);


// WEBPACK FOOTER //
// ./src/components/ScriptBar.js